module.exports = __webpack_public_path__ + "img/14.3d826ed9.jpg";